// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vant from 'vant';
import './assets/css/public.css' /*引入公共样式*/
import './assets/css/popup.css' /*引入公共样式弹出层*/
import './assets/css/wenda.css' /*引入公共样式问答*/
import './assets/css/course.css' /*引入公共样式课程*/
import 'vant/lib/index.css';
Vue.use(Vant);


import { Lazyload } from 'vant';

Vue.use(Lazyload);

import { Notify } from 'vant';

Vue.use(Notify);
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
    lazyComponent: true
});

import axios from 'axios'
Vue.prototype.$axios = axios;

Vue.config.productionTip = false
Vue.filter('dateFormat', (dataStr) => {
    var time = new Date(dataStr);

    function timeAdd0(str) {
        if (str < 10) {
            str = '0' + str;
        }
        return str
    }
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y + '-' + timeAdd0(m) + '-' + timeAdd0(d) + ' ' + timeAdd0(h) + ':' + timeAdd0(mm) // + ':' + timeAdd0(s);
})

Vue.filter('dateFormat1', (dataStr) => {
    var time = new Date(dataStr);

    function timeAdd0(str) {
        if (str < 10) {
            str = '0' + str;
        }
        return str
    }
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y + '-' + timeAdd0(m) + '-' + timeAdd0(d)
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js